function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#90DFAA"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M368,196.4L368,196.4L368,196.4L368,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M384.8,225.6c1.2-4.8,2-9.6,2.4-14c-4.4-14-19.2-15.2-19.2-15.2s-14.8,1.2-19.2,15.2 c0.8,4.4,1.6,8.8,2.4,14H384.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M385.6,174c0,0,2.4,12.4-17.6,22.4h-0.4C348,186.8,350,174,350,174l0,0v-0.4c4.8,6,11.2,10,17.6,10 c6.8,0,12.8-4,17.6-10C385.6,174,385.6,174,385.6,174L385.6,174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M354,177.6l-3.2,1.6c-1.2-3.2-0.8-5.2-0.8-5.2l0,0v-0.4C351.2,175.2,352.8,176.4,354,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M385.6,174c0,0,0.4,2-0.4,5.2l-3.2-1.6c1.2-1.2,2.4-2.4,3.6-4C385.6,174,385.6,174,385.6,174 L385.6,174z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M368,196.4L368,196.4L368,196.4L368,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M374.8,198.4l-2.4,6.8h-9.6l-2.4-6.8c4-1.6,7.2-2,7.2-2S371.2,196.8,374.8,198.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF7058"
    },
    points: "375.6,225.6 372.8,205.2 363.2,205.2 360.4,225.6 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M384.8,225.6H434l-8.8-26.8l-35.6-17.2c2.8,11.6-2.4,30.8-2.4,30.4 C386.8,216,385.6,220.8,384.8,225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M351.2,225.6c-1.2-4.8-2-9.6-2.4-14l0,0c-0.4-0.4-5.2-18.8-2.4-30.4l-35.6,17.2l-8.8,27.2H351.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M385.6,174c0,0,2.4,12.8-17.6,22.4c0,0,14.8,1.2,19.2,15.2C387.6,212,395.6,181.6,385.6,174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M350,174c0,0-2.4,12.8,17.6,22.4c0,0-14.8,1.2-19.2,15.2C348.4,212,340.4,181.6,350,174z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M390.4,160c-2.4,7.6-3.2,11.6-3.2,11.6l0,0c-5.2,7.2-12,12-19.2,12c-6.8,0-13.2-4.4-18.4-10.8l0,0 c-10.8-13.6-3.6-38-3.6-38c5.6,6.4,23.2,6.8,23.2,6.8c-7.6-1.2-8.8-7.6-8.8-7.6c1.2,3.6,18.4,6,18.4,6 C396.4,142.8,390.4,160,390.4,160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M357.6,108.8c0,0,24-9.6,36.4,12.4c13.2,23.2-3.2,48.4-6.8,50.4c0,0,0.8-4,3.2-11.6c0,0,6-17.2-12-20 c0,0-17.2-2.4-18.4-6c0,0,1.2,6.4,8.8,7.6c0,0-17.6-0.4-23.2-6.8c0,0-7.6,24.8,3.6,38c0,0-18.8-15.2-16.8-38.4 C333.2,134.4,332,102.4,357.6,108.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M140,196.4L140,196.4L140,196.4L140,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M156.8,225.6c1.2-4.8,2-9.6,2.4-14c-4.4-14-19.2-15.2-19.2-15.2s-14.8,1.2-19.2,15.2 c0.8,4.4,1.6,8.8,2.4,14H156.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M158,174c0,0,2.4,12.4-17.6,22.4H140c-20-9.6-17.6-22.4-17.6-22.4l0,0v-0.4c4.8,6,11.2,10,17.6,10 c6.8,0,12.8-4,17.6-10C158,174,158,174,158,174L158,174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M126,177.6l-3.2,1.6c-0.8-3.2-0.4-5.2-0.4-5.2l0,0v-0.4C123.6,175.2,124.8,176.4,126,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M158,174c0,0,0.4,2-0.4,5.2l-3.6-1.6c1.2-1.2,2.4-2.4,3.6-4C158,174,158,174,158,174L158,174z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M140,196.4L140,196.4L140,196.4L140,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M147.2,198.4l-2.4,6.8h-9.6l-2.4-6.8c4-1.6,7.2-2,7.2-2S143.2,196.8,147.2,198.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF7058"
    },
    points: "147.6,225.6 144.8,205.2 135.2,205.2 132.4,225.6 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M156.8,225.6H206l-8.8-26.8L162,181.2c2.8,11.6-2.4,30.8-2.4,30.4C158.8,216,158,220.8,156.8,225.6z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M123.2,225.6c-1.2-4.8-2-9.6-2.4-14l0,0c-0.4-0.4-5.2-18.8-2.4-30.4l-35.6,17.2L74,225.6H123.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M158,174c0,0,2.4,12.8-17.6,22.4c0,0,14.8,1.2,19.2,15.2C159.6,212,167.6,181.6,158,174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.4,174c0,0-2.4,12.8,17.6,22.4c0,0-14.8,1.2-19.2,15.2C120.4,212,112.4,181.6,122.4,174z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M162.8,160c-2.4,7.6-3.2,11.6-3.2,11.6l0,0c-5.2,7.2-12,12-19.2,12c-6.8,0-13.2-4.4-18.4-10.8l0,0 c-10.8-13.6-3.6-38-3.6-38c5.6,6.4,23.2,6.8,23.2,6.8c-7.6-1.2-8.8-7.6-8.8-7.6c1.2,3.6,18.4,6,18.4,6 C168.4,142.8,162.8,160,162.8,160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M130,108.8c0,0,24-9.6,36.4,12.4c13.2,23.2-3.2,48.4-6.8,50.4c0,0,0.8-4,3.2-11.6c0,0,6-17.2-12-20 c0,0-17.2-2.4-18.4-6c0,0,1.2,6.4,8.8,7.6c0,0-17.6-0.4-23.2-6.8c0,0-7.6,24.8,3.6,38c0,0-18.8-15.2-16.8-38.4 C105.2,134.4,104.4,102.4,130,108.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M254.4,192.8L254.4,192.8L254.4,192.8L254.4,192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M278,225.6c0.8-4.4,1.6-8.4,2-12.4c-6-18.8-26-20.4-26-20.4s-20,1.6-26,20.4c0.4,4,1.2,8,2,12.4H278 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M278,162.8c0,0,3.2,16.8-23.6,29.6H254c-26.8-12.8-23.6-29.6-23.6-29.6l0,0c0-0.4,0-0.4,0-0.8 c6.8,8,14.8,13.2,23.6,13.2c8.8,0,17.2-5.2,23.6-13.2C278,162.4,278.4,162.8,278,162.8C278.4,162.8,278,162.8,278,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M235.6,167.6l-4.4,2c-1.2-4-0.8-6.8-0.8-6.8l0,0c0-0.4,0-0.4,0-0.8C232.4,164,234,166,235.6,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M278,162.8c0,0,0.4,2.8-0.8,6.8l-4.4-2c1.6-1.6,3.6-3.2,5.2-5.2C278,162.4,278.4,162.8,278,162.8 C278.4,162.8,278,162.8,278,162.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M254.4,192.8L254.4,192.8L254.4,192.8L254.4,192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C0EB"
    },
    d: "M263.6,195.2l-3.2,9.2H248l-3.2-9.2c5.2-2.4,9.6-2.4,9.6-2.4S258.8,193.2,263.6,195.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#84DBFF"
    },
    points: "263.6,225.6 260.8,204.4 248,204.4 245.2,225.6 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M278,225.6h62.8l-9.6-30l-47.6-22.8c3.6,15.6-3.2,41.2-3.2,40.4C279.6,217.2,278.8,221.2,278,225.6z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M230.8,225.6c-0.8-4.4-1.6-8.4-2-12.4l0,0c-0.4-0.4-6.8-25.2-3.2-40.4L178,195.6l-9.6,30 L230.8,225.6L230.8,225.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278,162.8c0,0,3.2,16.8-23.6,30c0,0,20,1.6,26,20.4C280.4,213.6,291.2,172.8,278,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M230.8,162.8c0,0-3.2,16.8,23.6,30c0,0-20,1.6-26,20.4C228.4,213.6,217.6,172.8,230.8,162.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M284.8,144c-3.2,10-4.4,15.2-4.4,15.6l0,0c-6.8,9.6-16,16-25.6,16c-9.2,0-18-5.6-24.4-14.4l0.4,0.4 c-14.4-18-4.4-50.8-4.4-50.8c7.2,8.4,30.8,8.8,30.8,8.8c-10.4-1.6-12-10-12-10c1.6,4.8,24.4,8,24.4,8 C292.4,120.8,284.8,144,284.8,144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M240.8,75.6c0,0,32-12.8,48.4,16.4c17.6,31.2-4.4,64.8-8.8,67.6c0,0,1.2-5.6,4.4-15.6 c0,0,8-23.2-15.6-26.4c0,0-22.8-3.2-24.4-8c0,0,1.6,8.4,12,10c0,0-23.6-0.4-30.8-8.8c0,0-10,33.2,4.4,50.8c0,0-25.2-20.4-22.4-51.6 C208,110,206.4,67.2,240.8,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M398.8,288.4l40-9.6V252h-90c0,52.4-42.4,94.8-94.8,94.8s-94.8-42.4-94.8-94.8H69.6v26.8l40,9.6 c3.6,14.4,9.2,28,16.8,40.4l-21.2,34.8l37.6,37.6l34.8-21.2c12.4,7.6,26,13.2,40.4,16.8l9.6,40h53.2l9.6-40 c14.4-3.6,28-9.2,40.4-16.8l34.8,21.2l37.6-37.6L382,329.2C389.6,316.4,395.2,302.8,398.8,288.4z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm);
export default __webpack_public_path__ + "static/media/pm.97de74a9818e51aa3fec665d0baf1913.svg";
export { ForwardRef as ReactComponent };